import { render, staticRenderFns } from "./Detalhe.vue?vue&type=template&id=12462c99&scoped=true"
import script from "./Detalhe.vue?vue&type=script&lang=js"
export * from "./Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Detalhe.vue?vue&type=style&index=0&id=12462c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12462c99",
  null
  
)

export default component.exports